/* istanbul ignore file -- api */
import * as NewsletterSubscribeEvent from '@ori-events/newsletter-subscribe';
import {
  type GlobalNewsletterSubscriptionsNewsletterSubscriptionStatusDtoStatus as Status,
  createNewsletterSubscription,
  useApiClient,
} from '@ori/global-api-client-react';
import Cookies from 'js-cookie';
import { useCallback } from 'react';

import { useNewsletterDialogContext } from '../components/Subscribe/components/NewsletterDialog/components/NewsletterDialogContext';
import { SubscriptionProcessStatus } from '../components/Subscribe/components/NewsletterDialog/types';
import { newsletterSubscribeCookieKey, newsletterSubscribeCookieValue } from '../constants';
import { type CreateNewsletterSubscriptionParams } from './types';

const SUCCESS_STATUSES = new Set<Status>(['New', 'Subscribed', 'Pending']);

export const useCreateNewsletterSubscription = () => {
  const globalApiClient = useApiClient();
  const { setStatus } = useNewsletterDialogContext();

  const createSubscription = useCallback(
    async ({ origin, email }: CreateNewsletterSubscriptionParams) => {
      globalThis.dispatchEvent(new CustomEvent(NewsletterSubscribeEvent.Name));

      const result = await createNewsletterSubscription(globalApiClient, {
        email,
        source: window.location.pathname,
        origin,
      });

      if (result.status === 200 && SUCCESS_STATUSES.has(result.data.status)) {
        Cookies.set(newsletterSubscribeCookieKey, newsletterSubscribeCookieValue);
        setStatus(SubscriptionProcessStatus.Subscribed);
      } else {
        setStatus(SubscriptionProcessStatus.Failed);
      }
    },
    [globalApiClient, setStatus],
  );

  return { createSubscription };
};
